'use strict';

angular.module('webAgro1App').filter('formatDynamicDecimals', formatDynamicDecimals);

formatDynamicDecimals.$inject = ['DecimalsService'];

function formatDynamicDecimals(DecimalsService) {
  function formatValue(value, useGrouping) {
    return Intl.NumberFormat('pt-BR', {
      minimumFractionDigits: 3,
      maximumFractionDigits: 4,
      useGrouping: useGrouping
    }).format(value);
  }

  return function(value, useGrouping) {
    if (value !== null && typeof value !== 'undefined' && value !== '') {
      const numericValue = Number(String(value).replace(',', '.'));

      const formattedValue = DecimalsService.isDecimalV2Enabled() ?
        DecimalsService.formatDoseOrQuantityForDisplay(numericValue) :
        numericValue;

      return formatValue(formattedValue, useGrouping !== false);
    }
  };
}
